import handleFetch from './handleFetch';
import { getUrlWithAccessCode } from './../stores/referrer';

type SendCardParams = {
  to: string;
  configId?: string;
  confirmation?: {
    medication: string;
    dose: string;
    quantity: string;
    pharmacy: string;
  };
  locale?: string;
  categories?: string[];
};

enum SendCardTargetParamName {
  EMAIL = 'email',
  PHONE = 'phone',
}

const sendCard =
  (url: string, paramName: SendCardTargetParamName) =>
  (params: SendCardParams): Promise<Response | Error> => {
    const data = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.SAAS_API_KEY || '',
      },
      body: JSON.stringify({
        ...params,
        [paramName]: params.to,
      }),
    };
    return handleFetch(getUrlWithAccessCode(url), data);
  };

export const emailCard = sendCard(`${process.env.SAAS_EMAIL_ENDPOINT}`, SendCardTargetParamName.EMAIL);
export const textCard = sendCard(`${process.env.SAAS_SMS_ENDPOINT}`, SendCardTargetParamName.PHONE);
